export const track = (event, properties = {}) => (
  new Promise((resolve, reject) => {
    window.analytics.track(event, properties, {}, resolve())
  })
)

export const trackPage = (pageName) => (
  window.analytics.page(pageName)
)
